import { type FC, useEffect, useState } from 'react';
import styles from './index.module.scss';
import { Area, AreaChart, Tooltip, ReferenceLine, ResponsiveContainer } from 'recharts';
import { useVaultRevenue } from '@hooks/use-vault-revenue';
import { numericFormat } from '@utils/index';
import { OpenapiClientParrotVault } from 'src/openapi/parrot-vault';
import dayjs from 'dayjs';
import type { CategoricalChartState } from 'recharts/types/chart/types';

interface OwnProps {
  summary: OpenapiClientParrotVault.GetVaultStatsSummaryResponse | undefined;
}
const EarnRevenueChart: FC<OwnProps> = ({ summary }) => {
  const currentTime = Math.floor(Date.now() / 1000);
  const { revenue } = useVaultRevenue();
  const [num, setNum] = useState(0);
  const [timestamp, setTimestamp] = useState<number>(currentTime);
  const [hoverY, setHoverY] = useState<number>(-1);

  const handleMouseMove = (e: CategoricalChartState) => {
    const payload = e.activePayload as unknown as {
      payload: OpenapiClientParrotVault.GetVaultStatsChartRevenuesResponse[number];
    }[];
    if (payload[0]) {
      setHoverY(payload[0].payload.revenue_usd);
      setNum(payload[0].payload.revenue_usd);
      setTimestamp(payload[0].payload.timestamp);
    }
  };
  useEffect(() => {
    setNum(summary?.revenue_usd || 0);
  }, [summary?.revenue_usd]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.chart_data}>
        <div className={styles.chart_text1}>${numericFormat(num)}</div>
        <div className={styles.chart_text2}>Total Revenue</div>
        <div className={styles.chart_text3}>{dayjs(timestamp * 1000).format('MMM D, YYYY')}</div>
      </div>
      <div className={styles.chart_view}>
        {revenue && (
          <ResponsiveContainer width="100%" height="100%">
            <AreaChart
              width={360}
              height={120}
              data={revenue}
              onMouseMove={handleMouseMove}
              onMouseLeave={() => {
                setHoverY(-1);
                setNum(summary?.revenue_usd || 0);
                setTimestamp(currentTime);
              }}
            >
              <defs>
                <linearGradient id="colorGradient" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" stopColor="#F48420" stopOpacity={0.2} />
                  <stop offset="100%" stopColor="#F48420" stopOpacity={0} />
                </linearGradient>
              </defs>
              <Tooltip cursor={{ stroke: '#E6E8EC', strokeWidth: 1 }} content={<></>} />
              <ReferenceLine y={hoverY} stroke="#E6E8EC" />

              <Area
                type="monotone"
                dataKey="revenue_usd"
                stroke="#F48420"
                strokeWidth={2}
                fill="url(#colorGradient)"
                activeDot={{
                  r: 4,
                  fill: '#F48420',
                  stroke: 'rgba(244, 132, 32, 0.30)',
                  strokeWidth: 8,
                }}
              />
            </AreaChart>
          </ResponsiveContainer>
        )}
      </div>
    </div>
  );
};

export default EarnRevenueChart;
